import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import Frame from '../components/Frame.tsx';
import SketchBarChart from '../components/SketchBarChart';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "sketch-bar-chart"
    }}>{`Sketch Bar Chart`}</h1>
    <p>{`See the component `}<a parentName="p" {...{
        "href": "https://github.com/kristw/encodable/tree/master/packages/docs/src/components/SketchBarChart"
      }}>{`source code`}</a>{`.
or play with the component API by editing the code below.`}</p>

    <Playground __position={0} __code={'<Frame width={360} height={270} background=\"#B6312A\">\n  <SketchBarChart\n    width={360}\n    height={270}\n    padding={{ top: 30, left: 162, right: 60, bottom: 30 }}\n    encoding={{\n      x: {\n        field: \'calories\',\n        type: \'quantitative\',\n      },\n      y: {\n        field: \'menu\',\n        type: \'nominal\',\n        scale: { type: \'band\' },\n      },\n      color: { value: \'#E1D453\' },\n      label: { field: \'menu\' },\n    }}\n    data={[\n      {\n        menu: \'Egg McMuffin\',\n        calories: 300,\n      },\n      {\n        menu: \'Hotcakes\',\n        calories: 350,\n      },\n      {\n        menu: \'Big Mac\',\n        calories: 530,\n      },\n      {\n        menu: \'Hamburger\',\n        calories: 240,\n      },\n      {\n        menu: \'Cheeseburger\',\n        calories: 290,\n      },\n      {\n        menu: \'McChicken\',\n        calories: 360,\n      },\n      {\n        menu: \'French Fries\',\n        calories: 230,\n      },\n    ]}\n  />\n</Frame>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Frame,
      SketchBarChart,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Frame width={360} height={270} background="#B6312A" mdxType="Frame">
    <SketchBarChart width={360} height={270} padding={{
          top: 30,
          left: 162,
          right: 60,
          bottom: 30
        }} encoding={{
          x: {
            field: "calories",
            type: "quantitative"
          },
          y: {
            field: "menu",
            type: "nominal",
            scale: {
              type: "band"
            }
          },
          color: {
            value: "#E1D453"
          },
          label: {
            field: "menu"
          }
        }} data={[{
          menu: "Egg McMuffin",
          calories: 300
        }, {
          menu: "Hotcakes",
          calories: 350
        }, {
          menu: "Big Mac",
          calories: 530
        }, {
          menu: "Hamburger",
          calories: 240
        }, {
          menu: "Cheeseburger",
          calories: 290
        }, {
          menu: "McChicken",
          calories: 360
        }, {
          menu: "French Fries",
          calories: 230
        }]} mdxType="SketchBarChart" />
  </Frame>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      